<template>
  <div class="ui segments">
    <div class="ui clearing segment">

      <div class="ui breadcrumb mw-breadcrumb stackable equal width compact">

          <router-link :to="{ name: 'goods' }" class="section">
            Preces
          </router-link>
          <span class="divider">/</span>
          <router-link v-if="item.categoryA" :to="{ name: 'goods' }" class="section">
            {{item.categoryA}}
          </router-link>
          <span class="divider">/</span>
          <router-link v-if="item.categoryB"  :to="{ name: 'goods' }" class="section">
            {{item.categoryB}}
          </router-link>
          <span class="divider">/</span>
          <router-link v-if="item.categoryC"  :to="{ name: 'goods' }" class="section">
            {{item.categoryC}}
          </router-link>
          <span v-if="item.categoryC" class="divider">/</span>
          <div class="active section">{{ item.goods_name }}</div>
          <!-- <div class="ui icon input search-box">
            <input type="text" placeholder="Meklēt..." @keyup="setSearchTerm($event.target.value)"
              :value="searchTerm" />
            <i class="search link icon"></i>
          </div> -->

      </div>
	  
      <good-card :key="rerenderKey" class="ui segment good-card-segment"></good-card>

    </div>
  </div>

</template>

<script>
  import goodCard from "./GoodCard";
  
  export default {
    components: {
      "good-card": goodCard
    },
    data(){
        return{
            goodItem: this.$store.state.goodStore.item,
        }
    },  
    computed: {
      item() {
        return this.$store.state.goodStore.item;
      },
    },
    metaInfo() {
      return {
        title: this.$store.state.goodStore.item.goods_name,
        meta: [
          { name: 'description', content: this.$store.state.goodStore.item.description },
          { property: 'og:title', content: this.$store.state.goodStore.item.goods_name },
          { property: 'og:site_name', content: "Memory Outlet" },
          { property: 'og:description', content: this.$store.state.goodStore.item.description  },
          { property: 'og:type', content: 'item' },
          { property: 'og:url', content: 'https://bioveikals.com/good/' + this.$store.state.goodStore.item.link },
          { property: 'og:image', content: this.$store.state.goodStore.item.images ? this.$store.state.goodStore.item.images[0].raw : "https://bioveikals.com" }
        ]
      }
    },
  };
</script>

<style scoped>

  .good-card-segment {
    border: none!important;
    box-shadow: none!important;
    padding: 0px!important;
  }

  .ui.attached.segment {
    margin: 0px;
    width: auto;
    border: none;
  }

  @media screen and (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
    .ms-search-box input {
      width: 170px !important;
    }
  }

  .ms-search-box {
    width: 170px !important;
    /* margin-top: 15px!important; */
    float: right !important;
    /* display: inline-block!important; */
    position: relative !important;
    margin-left: 10vh !important;
  }

  .ms-search-box-mobile,
  .ms-search-box-mobile input {
    width: 87vw;
  }

  #long-description {
    margin: 15px 0 !important;
  }

  a.read-more {
    color: #b4b1ab !important;
    display: inline-block;
    margin-bottom: 15px;
  }

  a.read-more:hover {
    color: #dadada !important;
  }

  .badge-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .search-box {
    float: inline-end !important;
    /* width: 100%; */
  }

  @media (min-width:300px) {

    .search-box {
      width: 100%;
      max-height: 38px;
    }


  }

  @media (min-width:500px) {

    .search-box {
      /* float: inline-end !important; */
      width: 100%;
      max-height: 38px;
    }

    .mw-breadcrumb {
     display: flex!important;
    }

  }

  @media (max-width:500px) {

    .search-box {
      /* float: inline-end !important; */
      width: 100%;
      max-height: 38px;
      margin-top: 0px;
    }


  }


  @media (min-width:767px) {
    .search-box {
    /* float: inline-end !important; */
    width: 50%;
    margin-left: auto;
    }

  }

  @media (min-width:993px) {
    .search-box {
      /* float: inline-end !important; */
      width: 40%;
      /* margin-left: 50%; */
    }

}


</style>


// WEBPACK FOOTER //
// GoodPage.vue?94e05e3c